import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { HEATING_FORM_DATA_ID } from '../constants';
import { translationsActions } from '../store/modules/translations/reducer';
import HeatingFormStepper from './HeatingFormStepper';
import { OrganismHeatingFormProps } from '../model/global';
import { stepsActions } from '../store/modules/steps/reducer';

const HeatingFormApp = (): JSX.Element => {

	const dispatch = useDispatch()
	// const apiUrls = useSelector(stepsSelector);

	useEffect(() => {
		const data = document.getElementById(HEATING_FORM_DATA_ID) as HTMLScriptElement;
		if (data) {
			const initdata = JSON.parse(data.innerText) as OrganismHeatingFormProps;
			dispatch(stepsActions.initApp(initdata))
			dispatch(translationsActions.initTranslations(initdata.translations));
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	// if (!apiUrls) return <>Hola</>
	return <HeatingFormStepper />;
};

export default HeatingFormApp;
